'use client';
import React from 'react';
import { useCart } from '@shopify/hydrogen-react';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';

/**
 * Render-less component. Mount inside any client component that contains an AddToCartButton.
 * Watches Shopify cart status and opens the CartDrawer when an add-to-cart completes.
 */
export const CartOpenOnAdd = () => {
  const { status } = useCart();
  const { push: openCart } = useModal(ModalID.cart);
  const prevStatusRef = React.useRef<string>(status);

  React.useEffect(() => {
    const prev = prevStatusRef.current;
    prevStatusRef.current = status;
    const wasMutating = prev === 'updating' || prev === 'creating' || prev === 'cartLineAdding';

    if (wasMutating && status === 'idle') {
      openCart();
    }
  }, [status, openCart]);

  return null;
};
